import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { ModalType } from '../../../shared/enum/EnumRepository';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { useExhibitionVenue } from '../../../shared/hooks/useApi/useExhibitionVenue';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import filterIcon from '../../../asset/icon/filter.png';

const ExhibitionMetaStationMobile: React.FC = () => {
  const { setStandardModal } = useModalStore();
  const { tags, filterData, selectedVenueId, loadTags } = useExhibitionVenue();
  const didRequestTags = useRef(false);
  const isActive = !!selectedVenueId;

  useEffect(() => {
    if (didRequestTags.current) return;
    didRequestTags.current = true;
    void loadTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasTags = tags.length > 0;
  const hasTypeFilter = Object.values(filterData.venueType).some((isSelected) => !isSelected);
  const hasActiveFilters =
    hasTypeFilter || filterData.admissionFree || filterData.openToday;

  const handleSelectTagModal = () => {
    setStandardModal({
      modalType: ModalType.SELECT_EXHIBITION_TAG_MOBILE,
      title: 'Labels',
      value: '',
      handleChange: () => {},
    });
  };

  const handleFilter = () => {
    setStandardModal({
      modalType: ModalType.FILTER_STATION_EXHIBITION,
      title: 'Filter',
      value: '',
      handleChange: () => {},
    });
  };

  return (
    <MetaStationComp $isActive={isActive} onClick={(e) => e.stopPropagation()}>
      <FilterCaption onClick={handleFilter}>
        <IconBtn $backgroundImg={filterIcon} />
        Filter
        {hasActiveFilters && (
          <FilterApplyingSummary>
            · {getModalMessage('FILTER_APPLYING')}
          </FilterApplyingSummary>
        )}
      </FilterCaption>
      {hasTags && (
        <MobileLabelBtn onClick={handleSelectTagModal}>
          <LabelBlock>Label </LabelBlock>
          {filterData.tagIds.length > 0 && (
            <SelectedTagCount>
              {' '}· {getModalMessage('TAG_SELECTED_COUNT', { count: filterData.tagIds.length })}
            </SelectedTagCount>
          )}
        </MobileLabelBtn>
      )}
    </MetaStationComp>
  );
};

const MetaStationComp = styled.section<{ $isActive: boolean }>`
  width: ${({ $isActive }) => ($isActive ? '0%' : '100%')};
  opacity: ${({ $isActive }) => ($isActive ? 0 : 1)};
  height: ${({ $isActive }) => ($isActive ? '0' : 'auto')};
  min-height: ${({ $isActive }) => ($isActive ? '0' : '36px')};
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  margin-bottom: ${({ $isActive }) => ($isActive ? '0' : '4px')};
  transition: all 0.7s ease-in-out;
  z-index: 3;
`;

const LabelBlock = styled.div`
  width: fit-content;
  height: 12px;
  display: flex;
  align-items: center;
`;

const MobileLabelBtn = styled.div`
  display: flex;
  width: fit-content;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
`;

const SelectedTagCount = styled.span`
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_01};
  font-style: italic;
  user-select: none;
`;

const FilterCaption = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  cursor: pointer;
  gap: 4px;
`;

const FilterApplyingSummary = styled.span`
  width: fit-content;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_01};
  font-style: italic;
  user-select: none;
  white-space: nowrap;
`;

const IconBtn = styled.div<{ $backgroundImg: string }>`
  width: clamp(10px, 2vw, 12px);
  height: clamp(10px, 2vw, 12px);
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
`;

export default ExhibitionMetaStationMobile;
